if (document.querySelector('.profile-fields') && !document.querySelector('#form-feature-form')) {
  document.addEventListener('phx:update', () => {
    // Scroll to first input with validation errors
    if (document.querySelector('.input.is-danger')) {
      document
        .querySelector('.input.is-danger')
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}
